import { render } from "./SteamPlaytimeTracker.vue?vue&type=template&id=5621cef4&scoped=true"
import script from "./SteamPlaytimeTracker.vue?vue&type=script&lang=js"
export * from "./SteamPlaytimeTracker.vue?vue&type=script&lang=js"

import "../styles/seo-page.css?vue&type=style&index=0&lang=css&external"
import "./SteamPlaytimeTracker.vue?vue&type=style&index=1&id=5621cef4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5621cef4"]])

export default __exports__